import { getToken, setToken, removeToken } from '@/libs/util'

export default {
  state: {
      token: getToken(),
      cmsId: 5,
      loyaltyId: 5,
      customerInfo: {},
      privilegeList: []
  },
  mutations: {
      setToken (state, token) {
          state.token = token
          setToken(token)
      },
      removeToken (state) {
          state.token = ''
          removeToken()
      },
      storeInfo (state, customerInfo) {
          state.customerInfo = customerInfo
          window.localStorage.setItem('customerInfo', JSON.stringify(customerInfo))
      },
      storePrivilegeList (state, privilegeList) {
          state.privilegeList = privilegeList
          window.localStorage.setItem('privilegeList', JSON.stringify(privilegeList))
      }
  },
  getters: {
      getInfo (state) {
          return state.customerInfo
      },
      getPrivilegeList (state) {
          return state.privilegeList
      }
  },
  actions: {}
}
